import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import SearchPageLink from './search-page-link';
import CategoryPageLink from './category-page-link';
import './filter-categories.scss';
import ArrowIcon from '@tradera/tradera-ui/icons/arrow-down.svg?jsx';
import PAGE_TYPES from 'constants/page-types';
import { stripPaginationFromQueryParameters } from 'utils/url';
import * as gtm from '../../search-gtm';

class CategoryFilters extends Component {
    constructor(props) {
        super(props);
        this.state = {
            expanded: false
        };
    }

    render() {
        const {
            filterCategories,
            handleCategoryChange,
            pageType,
            queryParams
        } = this.props;
        const { expanded } = this.state;
        if (!filterCategories || !filterCategories.categoryTree) {
            return null;
        }
        const { categoryTree } = filterCategories;
        const { children } = categoryTree;
        const categoryResultPage = pageType === PAGE_TYPES.CATEGORY_RESULT_PAGE;

        const trackCategoryClick = (category, path) => {
            let strPath = [...path, category.name].join(' > ');
            gtm.trackFilter('categorySelected', strPath);
        };

        // recursive component
        const Category = ({ categories, className, path }) =>
            categories && categories.length > 0 ? (
                <Fragment>
                    {categories.map((category, index) => (
                        <div
                            key={category.id}
                            className={`${className} ${
                                index > 10 && !expanded ? 'd-none' : 'd-block'
                            }`}>
                            {categoryResultPage ? (
                                <CategoryPageLink
                                    category={category}
                                    onClick={() =>
                                        trackCategoryClick(category, path)
                                    }
                                    queryParams={stripPaginationFromQueryParameters(
                                        queryParams
                                    )}
                                />
                            ) : (
                                <SearchPageLink
                                    category={category}
                                    handleCategoryChange={category => {
                                        trackCategoryClick(category, path);
                                        handleCategoryChange(category);
                                    }}
                                />
                            )}
                            {category.children && (
                                <Category // calls self
                                    categories={category.children}
                                    className="ml-3"
                                    path={[...path, category.name]}
                                />
                            )}
                        </div>
                    ))}
                </Fragment>
            ) : null;

        return (
            <div className="filter-categories" data-test-filter-categories>
                <Fragment>
                    <Category
                        categories={[categoryTree]}
                        className=""
                        path={[]}
                    />
                    {children.length > 10 && !expanded ? (
                        <button
                            className="btn btn-sm btn-toggle my-2"
                            onClick={() => {
                                this.setState({
                                    expanded: true
                                });
                            }}>
                            Visa fler kategorier
                            <ArrowIcon className="icon icon-xs ml-3" />
                        </button>
                    ) : null}
                </Fragment>
            </div>
        );
    }
}

CategoryFilters.propTypes = {
    filterCategories: PropTypes.shape({
        categoryTree: PropTypes.object,
        parameter: PropTypes.string,
        type: PropTypes.string
    }).isRequired,
    handleCategoryChange: PropTypes.func,
    pageType: PropTypes.string.isRequired,
    queryParams: PropTypes.object.isRequired
};

export default CategoryFilters;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/search-results/filters/categories/filter-categories.jsx